import { render, staticRenderFns } from "./Sahifa.vue?vue&type=template&id=1a00ee5a&scoped=true&"
import script from "./Sahifa.vue?vue&type=script&lang=js&"
export * from "./Sahifa.vue?vue&type=script&lang=js&"
import style0 from "./Sahifa.vue?vue&type=style&index=0&id=1a00ee5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a00ee5a",
  null
  
)

export default component.exports